import { render, staticRenderFns } from "./EditSchedule.vue?vue&type=template&id=81d56d50&scoped=true"
import script from "./EditSchedule.vue?vue&type=script&lang=js"
export * from "./EditSchedule.vue?vue&type=script&lang=js"
import style0 from "./EditSchedule.vue?vue&type=style&index=0&id=81d56d50&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81d56d50",
  null
  
)

export default component.exports